import { defineSlotRecipe } from '@chakra-ui/react';

export const recipe = defineSlotRecipe({
  slots: [ 'root', 'row', 'cell', 'columnHeader', 'caption', 'footer', 'body', 'header' ],
  base: {
    root: {
      tableLayout: 'fixed',
      fontVariant: 'normal',
      fontVariantLigatures: 'no-contextual',
      borderCollapse: 'separate',
      borderSpacing: '0 10px',
      width: 'full',
      textAlign: 'start',
      verticalAlign: 'top',
      overflow: 'unset',
      paddingTop: '2px',
    },
    cell: {
      textAlign: 'start',
      alignItems: 'center',
      verticalAlign: 'center',
      fontWeight: 'normal',
    },
    columnHeader: {
      fontWeight: 'medium',
      textAlign: 'start',
    },
  },

  variants: {
    variant: {
      line: {
        columnHeader: {
          color: 'table.header.fg',
          backgroundColor: 'table.header.bg',
          borderWidth: 0,
          _first: {
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          },
          _last: {
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
          },
        },
        cell: {
          borderTopWidth: '1px',
          borderBottomWidth: '1px',
          _first: {
            borderLeftWidth: '1px',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          },
          _last: {
            borderRightWidth: '1px',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
          },
          borderColor: 'table.cell.border',
        },
        row: {
          bg: 'bg',
        },
      },
    },

    size: {
      md: {
        root: {
          fontSize: 'md',
        },
        columnHeader: {
          px: '6px',
          py: '10px',
          fontSize: 'sm',
          _first: {
            pl: 4,
          },
          _last: {
            pr: 4,
          },
        },
        cell: {
          px: '6px',
          py: 4,
          _first: {
            pl: 4,
          },
          _last: {
            pr: 4,
          },
        },
      },
      lg: {
        columnHeader: {
          px: '6px',
          py: '10px',
          fontSize: 'sm',
          _first: {
            pl: 4,
          },
          _last: {
            pr: 4,
          },
        },
        cell: {
          px: '6px',
          py: 5,
          _first: {
            pl: 4,
          },
          _last: {
            pr: 4,
          },
        },
      },
    },
  },

  defaultVariants: {
    variant: 'line',
    size: 'md',
  },
});
